module.exports = __webpack_public_path__ + "static/img/zongji2.2404f999.png";